/**
 * SC-158: shared limits for virtual-background uploads.
 *
 * The server enforces these; the client reads the same values so it can tell
 * someone where they stand before they pick a file. Declared once so the two
 * cannot drift apart.
 */

/** Owner decision (2026-08-24): under Back4App's own 20 MB default ceiling. */
export const MAX_BACKGROUND_UPLOAD_BYTES = 15 * 1024 * 1024

/** Owner decision (2026-08-25): a convenience gallery, not a photo library. */
export const MAX_PERSONAL_BACKGROUNDS = 3

/** Owner decision (2026-08-25): one company's shared set, kept small for the picker. */
export const MAX_WORKSPACE_BACKGROUNDS = 10

/** Raster formats every supported browser decodes; SVG is a document, never allowed. */
export const BACKGROUND_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const

export type BackgroundContentType = (typeof BACKGROUND_CONTENT_TYPES)[number]
